import { chatSidebarOpenAtom } from '@/atoms/chatSidebarAtoms';
import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { useIsClinicalCodingDashboardEnabled } from '@/features/flags';
import { codingDashboardMessages, useCodingDashboardPermissions } from '@heidi/coding';
import { useSetAtom } from 'jotai';
import { ClipboardList } from 'lucide-react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../../mobile';
import { NavItem } from '../nav-item';

export const CodingDashboardNavItem = () => {
  const intl = useIntl();
  const { dismissMobileSidebar } = useMobilePanel();
  const setChatSidebarOpen = useSetAtom(chatSidebarOpenAtom);
  const isEnabled = useIsClinicalCodingDashboardEnabled();
  const { canViewDashboard } = useCodingDashboardPermissions();

  const onClick = useCallback(() => {
    setSidebarOpenTab(undefined);
    setChatSidebarOpen(false);
    dismissMobileSidebar();
  }, [dismissMobileSidebar, setChatSidebarOpen]);

  if (!isEnabled || !canViewDashboard) {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage(codingDashboardMessages.title)}
      icon={<ClipboardList />}
      href="/coding-dashboard"
      onClick={onClick}
      testId="sidebar-link-view-coding-dashboard"
    />
  );
};
